/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SystemAutomation/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Action from './Action/index'
import Event from './Event/index'
import React from 'react'
import TysiaIconArrowRightAlt from 'DesignSystem/Svgs/TysiaIconArrowRightAlt/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function SystemAutomation({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentAutomations/AutomationsList/EnableAutomationHub/Empty/SystemAutomation"
  
}) {
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="SystemAutomation.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Event
  viewPath={`${viewPath}/Event`}
/>
<TysiaIconArrowRightAlt
  viewPath={`${viewPath}/TysiaIconArrowRightAlt`}
 width={18}
 height={18}
 fill={dtColorsNeutral400}
/>
<Action
  viewPath={`${viewPath}/Action`}
/>
</div>
{children}
</React.Fragment>)
}